//import React from 'react';
import {React, useEffect, useState, useRef, useLayoutEffect} from 'react';
import './popup_divs.css';
import '../App.css'



const PopUp_Divs = ( {data, pageKey = 'default'} ) => {
    const [isVisibleCenter, setIsVisibleCenter] = useState(false);
    const centerRef = useRef(null);

    const handleScroll9 = () => {
    
        if (centerRef.current) {
          const centerRect = centerRef.current.getBoundingClientRect();
          const triggerOffsetCenter = 200; // Adjust this value for different trigger points
          const triggerPointCenter = window.innerHeight - triggerOffsetCenter;
          const isAboveTriggerPointCenter = centerRect.top < triggerPointCenter;
          setIsVisibleCenter(isAboveTriggerPointCenter);
        }
    
      };
    
      useEffect(() => {
        window.addEventListener('scroll', handleScroll9);
        handleScroll9(); // Check visibility on initial render
        return () => {
          window.removeEventListener('scroll', handleScroll9);
        };
      }, []);
    
        
        useEffect(() => {
            const hash = window.location.hash.substring(1);
            if (hash) {
              const targetElement = document.getElementById(hash);
              if (targetElement) {
                targetElement.scrollIntoView({ behavior: 'smooth' });
              }
            }
          }, []);

          // Default content if nothing is passed
    const popups = data || [
        { h2: "Default 1", p: "Default paragraph 1" },
        { h2: "Default 2", p: "Default paragraph 2" },
        { h2: "Default 3", p: "Default paragraph 3" },
    ];

return (
    <div id='m4_container'>
      <div id='m4popup_container' ref={centerRef}>
        {popups.map((popup, i) => {
          const idx = i + 1;
          // Unique, page-scoped ID for CSS targeting (e.g., #popup_pic_home_1)
          const picId = `popup_pic_${pageKey}_${idx}`;

          // Optional per-item class override (e.g., 'pic-service-7'), added in addition to base + pageKey
          const extraPicClass = popup.picClass ? ` ${popup.picClass}` : '';

          // Optional per-item URL override
          const picStyle = popup.picUrl ? { backgroundImage: `url(${popup.picUrl})` } : undefined;

          return (
            <div
              key={i}
              id={`m4popup${idx}`}
              className={`m4_popup ${isVisibleCenter ? 'visible' : ''}`}
              style={{ transitionDelay: `${0.3 * idx}s` }}
            >
              <div className='popup_picdiv'>
                <div
                  id={picId}
                  className={`popup_pic theme-${pageKey}${extraPicClass}`}
                  style={picStyle}
                />
              </div>

              <div className='popup_texdiv'>
                <div id={`popup_buttons${idx}`} className='popup_buttons'>
                  {popup.buttons?.map((label, j) => (
                    <button key={j} className='popup_button'>{label}</button>
                  ))}
                </div>
                <h2>{popup.h2}</h2>
                <p>{popup.p}</p>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};
   

export default PopUp_Divs;


/*
return (
        <div id='m4_container'>
            <div id='m4popup_container' ref={centerRef}>
                {popups.map((popup, i) => (
                  <div key={i} id={`m4popup${i+1}`} className={`m4_popup ${isVisibleCenter ? 'visible' : ''}`} style={{ transitionDelay: `${0.3*(i+1)}s` }}>
                    <div className='popup_picdiv'>
                      <div id={`popup_pic${i+1}`} className='popup_pic'></div>
                    </div>
                    <div className='popup_texdiv'>
                      <div id={`popup_buttons${i+1}`} className='popup_buttons'>
                        {popup.buttons && popup.buttons.map((label, j) => (
                        <button key={j} className="popup_button">{label}</button>
                          ))}
                      </div>
                      <h2>{popup.h2}</h2>
                      <p>{popup.p}</p>
                    </div>
                  </div>
                ))}
            </div>
        </div>
    );
};
 




return (
        <div id='m4_container'>
              <div id='m4popup_container'ref={centerRef}>
                <div id='m4popup1' className={`m4_popup ${isVisibleCenter ? 'visible' : ''}`} style={{ transitionDelay: '.3s' }}>
                  <div className='popup_picdiv'>
                    <div id='popup_pic1' className='popup_pic'></div>
                  </div>
                  <div className='popup_texdiv'>
                    <h2>You'll Always Know What's Going On</h2>
                    <p>We call you first. We explain what's wrong, what it'll 
                      cost, and why it matters - plain and simple. No surprise bills. Ever. .</p>
                  </div>
                </div>
                <div id='m4popup2' className={`m4_popup ${isVisibleCenter ? 'visible' : ''}`} style={{ transitionDelay: '.6s' }}>
                  <div className='popup_picdiv'>
                    <div id='popup_pic2' className='popup_pic'></div>
                  </div>
                    <div className='popup_texdiv'>
                      <h2>We Check the Whole Car, Not Just One Problem</h2>
                      <p>We look at everything so you can decide what's best. You'll 
                        leave knowing your car is safe and running right - not just patched up.</p>
                    </div>
                </div>
                <div id='m4popup3' className={`m4_popup ${isVisibleCenter ? 'visible' : ''}`} style={{ transitionDelay: '.9s' }}>
                  <div className='popup_picdiv'>
                    <div id='popup_pic3' className='popup_pic'></div>
                  </div>
                    <div className='popup_texdiv'>
                      <h2>Honest Work. No Upsells</h2>
                      <p>We'll never sell you something you don't need. That's a promise.</p>
                    </div>
                </div>
              </div>
              
        </div>
    );
};*/